import React from "react";
import { useTranslation } from 'react-i18next';
import { createGTMTracking, getGTMAttributes } from '../../utils/gtm/gtm-tracking';
import { Button } from '../ui/atoms/Button';

interface BookDemoButtonProps {
  className?: string;
  variant?: "default" | "outlined";
  origin: 'hero' | 'interview_section' | 'mobile_menu';
}

const ArrowIcon = () => (
  <svg 
    className="w-4 h-4 sm:w-5 sm:h-5 text-dark-invirtus" 
    viewBox="0 0 24 24" 
    fill="none"
  >
    <path 
      d="M13 6L19 12L13 18" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
    />
    <path 
      d="M5 12H19" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
    />
  </svg>
);

export const BookDemoButton: React.FC<BookDemoButtonProps> = ({
  className = "",
  variant = "default",
  origin
}) => {
  const { t } = useTranslation('marketing');

  const handleBookDemo = () => {
    window.open('https://calendly.com/aida-invirtus/30min', '_blank');
  };

  const isOutlined = variant === "outlined";

  return (
    <Button
      label={t('cta.book_demo')}
      type={isOutlined ? "outlined" : "contained"}
      intent="secondary"
      size={isOutlined ? "md" : "lg"}
      rightIcon={isOutlined ? undefined : <ArrowIcon />}
      rightIconWithBackground={!isOutlined}
      onClick={handleBookDemo}
      className={`whitespace-nowrap ${className}`}
      {...getGTMAttributes(createGTMTracking('REQUEST_DEMO', { origin }))}
    />
  );
};
